// extracted by mini-css-extract-plugin
module.exports = {"root":"InputCheckbox_root__s5JB5","hideLabel":"InputCheckbox_hideLabel__3jGlN","input":"InputCheckbox_input__KsCnq"};